import { render, staticRenderFns } from "./pcgs.vue?vue&type=template&id=5589314d&scoped=true"
import script from "./pcgs.vue?vue&type=script&lang=js"
export * from "./pcgs.vue?vue&type=script&lang=js"
import style0 from "./pcgs.vue?vue&type=style&index=0&id=5589314d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5589314d",
  null
  
)

export default component.exports